import { useState, useEffect, useRef } from "react";

import { API_URL, scroll, getValFromLS } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Notice from "../components/Notice";
import Input from "../components/Input";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Nav from "./Nav";

const Users = () => {
	const [user, setUser] = useState({});
	const [subusers, setSubusers] = useState([]);
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		event1: "",
	});
	const [msg, setMsg] = useState({});
	const [notice, setNotice] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});
	const [alert2, setAlert2] = useState({});

	const formElement = useRef(null);

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};

			const url = new URL(`${API_URL}/dashboardUsersInit`);
			const params = {
				id: auth.id ? auth.id : "",
				type: auth.type ? auth.type : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });
					setSubusers(json.subusers);
					setAlert({});
					scroll();
				} else if (json && json.resp === 2) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });
					setAlert({});
					scroll();
					setAlert2({
						type: "error",
						text: json.text,
					});
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardUsers`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("auth", getValFromLS("dash", true));
		data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});
				setSubusers(json.subusers);
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleResend = async (e, type) => {
		e.preventDefault();

		const url = new URL(`${API_URL}/dashboardUsersResend`);
		let data = new FormData();
		data.append("type", type);
		data.append("auth", getValFromLS("dash", true));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setNotice({
					type: "success",
					text: json.text,
				});
				setSubusers(json.subusers);
			}
		} catch (error) {}
	};

	const handleRemove = async (e, type) => {
		e.preventDefault();

		const url = new URL(`${API_URL}/dashboardUsersRemove`);
		let data = new FormData();
		data.append("type", type);
		data.append("auth", getValFromLS("dash", true));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setNotice({
					type: "success",
					text: json.text,
				});
				setSubusers(json.subusers);
			}
		} catch (error) {}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Add Dashboard Users" />

						<p>
							Use this form to delegate a new user to access your dashboard and
							guest management functions.
						</p>

						<div className="spacer"></div>

						{alert2.type ? (
							<Alert data={alert2} />
						) : (
							<>
								<form
									ref={formElement}
									method="post"
									action="/"
									onSubmit={(e) => handleSubmit(e)}
									className="well"
								>
									<h4
										style={{
											marginTop: "0",
											lineHeight: "22px",
											marginBottom: "10px",
											fontSize: "1.1rem",
										}}
									>
										Add User Delegation
									</h4>

									<div className="form-group">
										<Input
											name="fname"
											label="First Name"
											reqd={true}
											value={names.fname || ""}
											autocomplete="given-name"
											update={handleUpdate}
											errors={errors}
										/>

										<Input
											name="lname"
											label="Last Name"
											reqd={true}
											value={names.lname || ""}
											autocomplete="family-name"
											update={handleUpdate}
											errors={errors}
										/>
									</div>

									<div className="form-group" style={{ marginBottom: "0" }}>
										<Input
											name="email"
											label="Email"
											reqd={true}
											value={names.email || ""}
											update={handleUpdate}
											errors={errors}
										/>

										<Input
											name="confirm"
											label="Confirm Email"
											reqd={true}
											value={names.confirm || ""}
											update={handleUpdate}
											errors={errors}
										/>
									</div>

									<p>
										An email will be sent to your specified user with their
										access link.
									</p>

									<div className="msg-submit">
										{msg.type && <Msg data={msg} />}

										<div
											className={
												msg.type === "working" || msg.type === "success"
													? "hidden"
													: "submit-container"
											}
										>
											<Submit submit="Add User Delegation" />
										</div>
									</div>
								</form>

								{notice.type && <Notice data={notice} />}

								<table className="approved assigned">
									<thead>
										<tr>
											<th colSpan="5" className="hdg">
												Your Dashboard Users
											</th>
										</tr>
										<tr>
											<td className="left">Name</td>
											<td className="center">Email</td>
											<td className="center" style={{ width: "15%" }}>
												Resend
											</td>
											<td className="center" style={{ width: "15%" }}>
												Remove
											</td>
										</tr>
									</thead>
									{subusers.length > 0 ? (
										<tbody>
											{subusers.map((item) => {
												return (
													<tr key={item.id}>
														<td className="left">
															<span>{item.name}</span>
														</td>
														<td className="center">
															<a href={`mailto:${item.email}`}>{item.email}</a>
														</td>
														<td>
															<button
																type="button"
																className="naked"
																title="Resend delegation email"
																onClick={(e) => handleResend(e, item.type)}
															>
																<i className="fa fa-envelope-o  fa-lg" />
															</button>
														</td>
														<td>
															<button
																type="button"
																className="naked"
																title="Remove delegation access"
																onClick={(e) => handleRemove(e, item.type)}
															>
																<i className="fa fa-trash error fa-lg" />
															</button>
														</td>
													</tr>
												);
											})}
										</tbody>
									) : (
										<tbody>
											<tr>
												<td
													className="center"
													colSpan="4"
													style={{ paddingTop: "15px", paddingBottom: "15px" }}
												>
													<span className="working">
														-- No current users found --
													</span>
												</td>
											</tr>
										</tbody>
									)}
								</table>
							</>
						)}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={6} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Users;
